import DrawerForm from "@shared/components/drawerForm";
import { CompanyLogsProps } from "./types";
import CompanyLogsItem from "./CompanyLogsItem";
import { Table, TableContainer, Tbody, Th, Thead, Tr } from "@chakra-ui/react";

const CompanyLogs = ({ isOpen, onClose, logs }: CompanyLogsProps) => {

    return (
        <DrawerForm isOpen={isOpen} onClose={onClose} closeOnOverlayClick title="Logs" location="bottom" size="full">
            <TableContainer bg="white" borderRadius={8} p={2} shadow="md">
                <Table variant="simple" size="sm">
                    <Thead>
                        <Tr>
                            <Th>ClaveOrigen</Th>
                            <Th>Mensaje</Th>
                            <Th>Estatus</Th>
                            <Th>Contexto</Th>
                            <Th>Fecha</Th>
                            <Th>Hora</Th>
                        </Tr>
                    </Thead>
                    <Tbody>
                        {
                            logs?.map((item) => (
                                <CompanyLogsItem data={item} key={item.id}/>
                            ))
                        }
                    </Tbody>
                </Table>
            </TableContainer>
                
           
        </DrawerForm>
    )
}

export default CompanyLogs;